let basePath,originPath,dictPath,webSockUrl,webSockAgreeOn
if (process.env.NODE_ENV === 'production' && process.env.RUN_ENV === 'production') {
    //正式
    basePath = '//yzims.oss-cn-shenzhen.aliyuncs.com/';
    originPath='https://static.yzou.cn/'
    dictPath = "//static.yzou.cn/cache/";
    webSockUrl="//monitor-exam.yzou.cn";
    webSockAgreeOn = "wss";
    

}else if(process.env.NODE_ENV === 'production' && process.env.RUN_ENV === 'devtest') {
    //预发布
    basePath = '//yzims.oss-cn-shenzhen.aliyuncs.com/';
    originPath='https://static.yzou.cn/'    
    // dictPath = "//img.yzwill.cn/cache/pre/";
    dictPath = "//static.yzou.cn/cache/";
    webSockUrl="//xk-exam.yzou.cn";
    webSockAgreeOn = "wss";
}else if(process.env.NODE_ENV ==='development') {
    // 本地

    basePath = '//yzimstest.oss-cn-shenzhen.aliyuncs.com/';
    originPath='http://img.yzwill.cn/'  //188
    // originPath='https://static.yzou.cn/'    //192
    // dictPath = "//img.yzwill.cn/cache/local/";
    dictPath = "//static.yzou.cn/cache/";
    // webSockUrl="//xk-exam.yzwill.cn"; //188
    webSockUrl="//xk-exam.yzou.cn"; //192
    webSockAgreeOn = "ws";
}

else{

    basePath = '//yzimstest.oss-cn-shenzhen.aliyuncs.com/';
    originPath='http://img.yzwill.cn/';
    dictPath = "//static.yzou.cn/cache/";
    // webSockUrl="//xk-exam.yzwill.cn";
    webSockUrl="//xk-exam.yzou.cn";
    webSockAgreeOn = "ws";
}

module.exports =  {
    imgBaseURL: originPath,
    // 上传图片的
    imgBasePath: originPath,
    webSockUrl:webSockUrl,
    dict:`${dictPath}dict.js?${Date.now()}`,
    webSockAgreeOn: webSockAgreeOn,
}


// WEBPACK FOOTER //
// ./src/config/index.js